/**
 * sticky-buy-bar.js — DJI-style frozen bottom buy bar (Factory 47).
 * Reveals when the main Add-to-Cart button leaves the viewport; the sticky Add
 * button delegates to the theme's real product form (so variant selection, cart
 * drawer, and the theme's own add logic all still apply). Additive, flag-gated.
 */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-buy-bar]');
  if (!bar) return;

  var form = document.querySelector('form.js-product-form-main') || document.querySelector('.product-info form[action*="/cart/add"]');
  var mainAdd = form ? form.querySelector('[name="add"]') : null;
  var stickyAdd = bar.querySelector('[data-sticky-add]');
  if (!mainAdd || !stickyAdd) { bar.parentNode && bar.parentNode.removeChild(bar); return; }

  // Sticky Add delegates to the real button (respects variant + opens cart drawer).
  stickyAdd.addEventListener('click', function () { if (!mainAdd.disabled) mainAdd.click(); });

  // Mirror the main button's disabled / sold-out state.
  function sync() {
    stickyAdd.disabled = mainAdd.disabled;
    var label = (mainAdd.textContent || '').replace(/\s+/g, ' ').trim();
    if (label) stickyAdd.textContent = label;
  }
  sync();
  if (window.MutationObserver) {
    new MutationObserver(sync).observe(mainAdd, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled'] });
  }

  // Mirror the theme's main price into the bar so it always reflects whatever the
  // customer actually sees — including WPD wholesale/dealer pricing and native sales
  // (WPD rewrites the main price element client-side; we copy it live).
  (function mirrorPrice() {
    try {
      var src = document.querySelector('.product-info .price') || document.querySelector('.price');
      var dst = bar.querySelector('.f47-sticky-bar__price');
      if (!src || !dst) return;
      // Copy only the price amounts (.price__default = current + struck compare),
      // not the unit-price / no-variant siblings.
      var copy = function () { var d = src.querySelector('.price__default'); dst.innerHTML = (d || src).innerHTML; };
      copy();
      if (window.MutationObserver) new MutationObserver(copy).observe(src, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  })();

  // Relocate the theme's express-checkout button (Shop Pay / Buy it now / Affirm)
  // into the bar. The bar is rendered inside the product form, so the button stays a
  // descendant of the form it reads the selected variant from -- we move the live node
  // instead of rendering a second one, because a form may only carry one dynamic
  // checkout button. If anything here fails we leave the button where it is; the CSS
  // below only hides the buy-box wrapper once the move has actually happened.
  (function moveExpressCheckout() {
    try {
      var slot = bar.querySelector('[data-sticky-express]');
      var wrapper = document.querySelector('.product-info__dynamic-checkout-button');
      var express = wrapper && wrapper.querySelector('.shopify-payment-button');
      if (!slot || !express) return;
      slot.appendChild(express);
      slot.hidden = false;
      wrapper.classList.add('is-relocated');
    } catch (e) {}
  })();

  // Dock the bar permanently and hand purchasing over to it: the body class hides
  // the default buy controls. It's added only now that the bar is fully wired, so a
  // script failure (early return above) leaves the normal buy button intact.
  bar.classList.add('is-visible');
  bar.setAttribute('aria-hidden', 'false');
  document.body.classList.add('f47-sticky-docked');

  // Publish the bar's real height as --f47-sticky-bar-height so other overlays can
  // clear it (see the chat-launcher rule in sticky-buy-bar.css). The height is not a
  // constant: the express-pay button can change size with the variant, and the row
  // can wrap on narrow viewports, so measure rather than hard-code.
  (function publishHeight() {
    try {
      var apply = function () {
        var h = Math.round(bar.getBoundingClientRect().height);
        if (h > 0) document.documentElement.style.setProperty('--f47-sticky-bar-height', h + 'px');
      };
      apply();
      if (window.ResizeObserver) new ResizeObserver(apply).observe(bar);
      else window.addEventListener('resize', apply);
    } catch (e) {}
  })();
})();
